/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */

import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Collapse, Divider } from '@mui/material';
import classNames from 'classnames';
import { MenuItems } from './menuItems';
import HLDLogo from '../assets/images/FooterLogo.png';
import FooterLogoSmall from '../assets/images/SidebarLogoFooterSmall.svg';
import { CollapsIcon } from '../assets/icons';
// import { styled } from '@mui/material/styles';
// import type { TooltipProps } from '@mui/material/Tooltip';
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import CustomTooltip from './CustomTooltip/CustomTooltip';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { LinkSquare01Icon } from '@hugeicons-pro/core-stroke-rounded';

// const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
//   <Tooltip {...props} arrow classes={{ popper: className }} placement="right" />
// ))(({ theme }) => ({
//   [`& .${tooltipClasses.arrow}`]: {
//     color: theme.palette.common.black,
//   },
//   [`& .${tooltipClasses.tooltip}`]: {
//     backgroundColor: theme.palette.common.black,
//   },
// }));

interface MenuFeature {
  menuFeatureId: number;
  menuFeature: string;
  hasPermission: boolean;
  isSubMenu: boolean;
  rightCode: string;
}

interface MenuItem {
  parentId: number;
  appRightId: number;
  rightName: string;
  rightCode: string;
  hasSubMenu: boolean;
  menuFeatures: MenuFeature[];
  children?: MenuItem[];
}

const Sidebar: React.FC<{ isCollapsed: boolean; setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>> }> = ({
  isCollapsed,
  setIsCollapsed,
}) => {
  const [activeSubmenu, setActiveSubmenu] = useState<number | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const [menuData, setMenuData] = useState<MenuItem[]>([]);
  const location = useLocation();
  const { pathname } = location;

  const buildMenuStructure = (data: MenuItem[]): MenuItem[] => {
    const idMap = new Map();
    const menuStructure: [] = [];

    data.forEach((item) => {
      //@ts-ignore
      idMap.set(item.appRightId, { ...item, children: [] });
    });

    data.forEach((item) => {
      if (item.parentId === 0) {
        //@ts-ignore
        menuStructure.push(idMap.get(item.appRightId));
      } else {
        const parent = idMap.get(item.parentId);
        if (parent?.hasSubMenu) {
          parent.children.push(idMap.get(item.appRightId));
        }
      }
    });

    const cleanStructure = (nodes: MenuItem[]): MenuItem[] =>
      nodes.map((node) => {
        const cleaned = { ...node };
        //@ts-ignore
        if (cleaned.hasSubMenu && cleaned.children.length > 0) {
          //@ts-ignore
          cleaned.children = cleaned.children.map((child: MenuItem) => {
            const childCopy = { ...child };
            delete childCopy.children;
            return childCopy;
          });
        } else {
          delete cleaned.children;
        }
        return cleaned;
      });

    return cleanStructure(menuStructure);
  };

  useEffect(() => {
    const storedappRights = JSON.parse(localStorage.getItem('appRights') ?? '[]');
    const menu = buildMenuStructure(storedappRights);
    setMenuData(menu);
  }, [pathname, isCollapsed]);

  useEffect(() => {
    const handleResize = (): void => {
      const isSmallScreen = window.innerWidth < 1200;
      setIsMobile(isSmallScreen);
      setIsCollapsed(isSmallScreen);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [setIsCollapsed]);

  // ✅ FIX: Close submenu when sidebar is collapsed
  useEffect(() => {
    if (isCollapsed && !isMobile) {
      setActiveSubmenu(null);
    }
  }, [isCollapsed, isMobile]);

  useEffect(() => {
    setActiveSubmenu(null);
    const matchedMenu = menuData.find((menu) => {
      const item = getMenuItem(menu.rightCode);
      if (!item) return false;

      // ✅ Updated logic to detect nested sub-paths
      if (pathname === item.link || pathname.startsWith(item.link + '/')) return true;
      return item.subMenu?.some((sub) =>
        pathname === sub.link || pathname.startsWith(sub.link + '/')
      );
    });

    if (matchedMenu) {
      setActiveSubmenu(matchedMenu.appRightId);
    }
  }, [menuData, pathname]);


  const handleSidebarToggle = useCallback(() => {
    setIsCollapsed((prev) => !prev);
  }, [setIsCollapsed]);
  const handleSubmenuToggle = useCallback(
    (id: number, hasSubMenus: boolean) => {
      if (!hasSubMenus) return;
  
      if (isCollapsed) {
        // Expand sidebar first
        setIsCollapsed(false);
  
        // Delay submenu toggle slightly until sidebar is expanded
        setTimeout(() => {
          setActiveSubmenu(id);
        }, 300); // Should match your sidebar expand animation duration
      } else {
        // Set this submenu as active and close any other
        setActiveSubmenu(id === activeSubmenu ? null : id);
      }
    },
    [isCollapsed, activeSubmenu, setIsCollapsed]
  );
  


  const getMenuItem = useCallback((rightCode: string) => {
    return MenuItems.find((item) => item.rightCode === rightCode);
  }, []);

  const renderDashboard = useCallback(() => {
    const dashboardMenuItem = MenuItems.find((item) => item.rightCode === 'DASHBOARD');
    if (!dashboardMenuItem) return null;

    const isActive = pathname === dashboardMenuItem.link;
    const iconStyle = {
      width: '18px',
      height: '18px',
      marginLeft: isCollapsed ? '0px' : '-8px',
      marginRight: isCollapsed ? '0px' : '5px',
    };

    return (
      <CustomTooltip title={isCollapsed ? 'Dashboard' : ''} placement="right" arrow={false}>
        <li className="py-2">
          <Link
            to={dashboardMenuItem.link}
            className={classNames(`menu-link py-2 flex items-center ${isCollapsed ? 'justify-center' : ''}`, {
              active: isActive,
            })}
            onClick={() => setIsCollapsed(isMobile)}
          >
            <div className="flex items-center gap-2">
              <div style={iconStyle}>
                {isActive ? dashboardMenuItem.activeIcon : dashboardMenuItem.icon}
              </div>
              {!isCollapsed && <span style={{ fontSize: '14px' }}>Dashboard</span>}
            </div>
          </Link>
        </li>
      </CustomTooltip>
    );
  }, [pathname, isCollapsed, isMobile, setIsCollapsed]);

  const renderMenuItems = useCallback(() => {
    if (menuData.length === 0) return null;

    return menuData.map((menu: MenuItem) => {
      if (menu.rightCode === 'DASHBOARD') return null;

      const menuItem = getMenuItem(menu.rightCode);
      if (!menuItem) return null;

      // ✅ Updated active logic to support nested paths like /admin/manage-clients/add-client
      const isActive =
        pathname === menuItem.link ||
        pathname.startsWith(menuItem.link + '/') ||
        menuItem.subMenu?.some((sub) =>
          pathname === sub.link || pathname.startsWith(sub.link + '/')
        );

      const iconStyle = {
        width: '18px',
        height: '18px',
        marginLeft: isCollapsed ? '0px' : '-8px',
        marginRight: isCollapsed ? '0px' : '5px',
      };

      const subMenus = menu.children ?? [];
      const hasSubMenus = menu.hasSubMenu && subMenus.length > 0;
      const isSubmenuOpen = activeSubmenu === menu.appRightId;

      if (!hasSubMenus) {
        return (
          <CustomTooltip title={isCollapsed ? menu.rightName : ''} placement="right" key={menu.appRightId} arrow={false}>
            <li className="py-2">
              <Link
                to={menuItem.link}
                className={classNames(`menu-link py-2 flex items-center ${isCollapsed ? 'justify-center' : ''}`, {
                  active: isActive,
                })}
                onClick={() => setIsCollapsed(isMobile)}
              >
                <div className="flex items-center gap-2">
                  <div style={iconStyle}>{isActive ? menuItem.activeIcon : menuItem.icon}</div>
                  {!isCollapsed && <span style={{ fontSize: '14px' }}>{menu.rightName}</span>}
                </div>
              </Link>
            </li>
          </CustomTooltip>
        );
      }

      return (
        <CustomTooltip title={isCollapsed ? menu.rightName : ''} placement="right" key={menu.appRightId} arrow={false}>
          <li className="py-2">
            <div
              className={classNames('menu-link py-2 cursor-pointer flex items-center justify-between', {
                active: isActive,
              })}
              onClick={() => handleSubmenuToggle(menu.appRightId, hasSubMenus)}
            >
              <div className="flex items-center gap-2">
                <div style={iconStyle}>{isActive ? menuItem.activeIcon : menuItem.icon}</div>
                {!isCollapsed && <span style={{ fontSize: '14px' }}>{menu.rightName}</span>}
              </div>
              {!isCollapsed && (
                <svg
                  className={classNames('ml-auto transition-transform duration-200', {
                    'transform rotate-180': isSubmenuOpen,
                  })}
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.33325 4.66675L5.99992 8.33341L9.66659 4.66675"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>

            {!isCollapsed && (
              <Collapse in={isSubmenuOpen} timeout="auto" unmountOnExit>
                <ul className="pl-4 mt-2 submenu">
                  {subMenus.map((child) => {
                    const subMenuItem = menuItem.subMenu?.find((sub) => sub.rightCode === child.rightCode);
                    if (!subMenuItem) {
                      return null;
                    }

                    return (
                      <li key={child.appRightId} className="pt-1 pb-1 flex submenu-item">
                        <Link
                          to={subMenuItem.link}
                          className={classNames('menu-link py-1 flex items-center', {
                            active:
                              pathname === subMenuItem.link ||
                              pathname.startsWith(subMenuItem.link + '/'),
                          })}
                          onClick={() => setIsCollapsed(isMobile)}
                        >
                          <span className="menu-link-text">{child.rightName}</span>
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </Collapse>
            )}
          </li>
        </CustomTooltip>
      );
    });
  }, [menuData, pathname, isCollapsed, activeSubmenu, getMenuItem, handleSubmenuToggle, isMobile, setIsCollapsed]);

  const renderAPIDocMenu = useCallback(() => {
    const supportMenuItem = MenuItems.find((item) => item.rightCode === 'APIDOC' || item.rightCode === "SUPPORT");
    if (!supportMenuItem) return null;

    const isActive = pathname === supportMenuItem.link;
    const iconStyle = {
      width: '18px',
      height: '18px',
      marginLeft: isCollapsed ? '0px' : '-8px',
      marginRight: isCollapsed ? '0px' : '5px',
    };

    return (
      <CustomTooltip title={isCollapsed ? 'API Docs' : ''} placement="right" arrow={false}>
        <li className="py-2">
          <Link
            to={supportMenuItem.link}
            target='_blank'
            className={classNames(`menu-link py-2 flex items-center ${isCollapsed ? 'justify-center' : ''}`, {
              active: isActive,
            })}
            onClick={() => setIsCollapsed(isMobile)}
          >
            <div className="flex items-center gap-2">
              <div style={iconStyle}>
                {isActive ? supportMenuItem.activeIcon : supportMenuItem.icon}
              </div>
              {!isCollapsed && <span style={{ fontSize: '14px' }}>API Docs</span>}
              {!isCollapsed && <HugeiconsIcon
                  icon={LinkSquare01Icon}
                  size={18}
                  color="currentColor"
                  strokeWidth={0.2}
                />}
            </div>
          </Link>
        </li>
      </CustomTooltip>
    );
  }, [pathname, isCollapsed, isMobile, setIsCollapsed]);

  const renderSupportMenu = useCallback(() => {
    const supportMenuItem = MenuItems.find((item) => item.rightCode === "SUPPORT");
    if (!supportMenuItem) return null;

    const isActive = pathname === supportMenuItem.link;
    const iconStyle = {
      width: '18px',
      height: '18px',
      marginLeft: isCollapsed ? '0px' : '-8px',
      marginRight: isCollapsed ? '0px' : '5px',
    };

    return (
      <CustomTooltip title={isCollapsed ? 'Support' : ''} placement="right" arrow={false}>
        <li className="py-2">
          <Link
            to={supportMenuItem.link}
            target='_blank'
            className={classNames(`menu-link py-2 flex items-center ${isCollapsed ? 'justify-center' : ''}`, {
              active: isActive,
            })}
            onClick={() => setIsCollapsed(isMobile)}
          >
            <div className="flex items-center gap-2">
              <div style={iconStyle}>
                {isActive ? supportMenuItem.activeIcon : supportMenuItem.icon}
              </div>
              {!isCollapsed && <span style={{ fontSize: '14px' }}>Support</span>}
              {!isCollapsed && <HugeiconsIcon
                  icon={LinkSquare01Icon}
                  size={18}
                  color="currentColor"
                  strokeWidth={0.2}
                />}
            </div>
          </Link>
        </li>
      </CustomTooltip>
    );
  }, [pathname, isCollapsed, isMobile, setIsCollapsed]);

  const wrapperClasses = classNames('bg-white flex justify-between flex-col', {
    ['max-w-[230px]']: !isCollapsed && !isMobile,
    ['min-w-[80px]']: isCollapsed || isMobile,
  });

  const collapseIconClasses = classNames('rounded bg-secondary absolute right-0', {
    'rotate-180 collapsed': isCollapsed,
  });

  return (
    <div className={wrapperClasses} style={{ transition: 'width 300ms cubic-bezier(0.2, 0, 0, 1)' }} >
      <div className="flex flex-col">
        <div className="flex items-center justify-between relative h-[64px]">
          <div className="flex items-center gap-4" style={{ margin: 'auto', padding: '10px' }}>
          <Link to="/dashboard">
            <img
              src={isCollapsed ? FooterLogoSmall : HLDLogo}
              alt="logo"
              width={isCollapsed ? 50 : 120}
              height={66}
              className={`mx-auto ${isCollapsed ? 'w-[30px] h-[40px] ml-[30px]' : 'w-[130px]'}`}
            />
            </Link>
          </div>
          <button className={collapseIconClasses} onClick={handleSidebarToggle} aria-label="Toggle sidebar">
            <CollapsIcon />
          </button>
        </div>

        <div className="flex flex-col items-center mt-5 px-4 overflow-y-auto overflow-x-hidden w-full">
          <ul className={classNames('menu sidebar-menu-container', { 'w-60': !isCollapsed })}>
            {renderDashboard()}
            {renderMenuItems()}
            <Divider />
            {renderAPIDocMenu()}
            {renderSupportMenu()}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
